/* Site-Specific JavaScript */

// Auto-submit forms when filter selects change
document.addEventListener('DOMContentLoaded', function() {
    // Vendor Resources filter
    const vendorResourcesSelect = document.querySelector('#vendor-resources-filter select');
    if (vendorResourcesSelect) {
        vendorResourcesSelect.addEventListener('change', function() {
            this.form.submit();
        });
    }
});

// Main Menu Parent Button Functionality
document.querySelectorAll('.has-children button').forEach(button => {
    const menuId = button.getAttribute('aria-controls');
    const menu = document.getElementById(menuId);
    const parentItem = button.closest('.has-children');
    let isMenuOpen = false;
    let wasOpenedByClick = false;

    function openMenu(byClick = false) {
        menu.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        isMenuOpen = true;
        wasOpenedByClick = byClick;
        // Make submenu links focusable when menu is open
        menu.querySelectorAll('ul li a').forEach(link => {
            link.setAttribute('tabindex', '0');
        });
    }

    function closeMenu() {
        menu.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        isMenuOpen = false;
        wasOpenedByClick = false;
        // Make submenu links non-focusable when menu is closed
        menu.querySelectorAll('ul li a').forEach(link => {
            link.setAttribute('tabindex', '-1');
        });
    }

    function toggleMenu() {
        if (isMenuOpen) {
            closeMenu();
        } else {
            openMenu(true); // Mark as opened by click
        }
    }

    // Handle both click and touch events for better touch device support
    function handleToggle(e) {
        e.preventDefault();
        toggleMenu();
    }

    // Handle touchstart to prevent click delay, but prevent double toggle
    button.addEventListener('touchstart', e => {
        e.preventDefault(); // Prevent the click event from firing
        handleToggle(e);
    });
    
    // Fallback for mouse clicks (when touchstart doesn't fire)
    button.addEventListener('click', e => {
        // Only handle click if it wasn't already handled by touchstart
        if (e.defaultPrevented) return;
        handleToggle(e);
    });

    // Handle hover events to manage hidden attribute
    parentItem.addEventListener('mouseenter', () => {
        if (!wasOpenedByClick) {
            openMenu(false); // Mark as opened by hover
        }
    });

    parentItem.addEventListener('mouseleave', () => {
        if (!wasOpenedByClick) {
            closeMenu();
        }
    });

    // Close on ESC from button or submenu
    [button, menu].forEach(el => {
        el.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                closeMenu();
                button.focus();
            }
        });
    });

    // Close when tabbing out of submenu
    menu.addEventListener('focusout', e => {
        // Use setTimeout to allow focus to move to the next element
        setTimeout(() => {
            if (!parentItem.contains(document.activeElement)) {
                closeMenu();
            }
        }, 10);
    });

    // Close when focus leaves button without entering submenu
    button.addEventListener('focusout', e => {
        // Use setTimeout to allow focus to move to the next element
        setTimeout(() => {
            if (!parentItem.contains(document.activeElement)) {
                closeMenu();
            }
        }, 10);
    });
});

// jQuery Validate applies novalidate, so the date input's min attribute needs its own rule.
function financialReportsToday() {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return now.getFullYear() + '-' + month + '-' + day;
}

jq.validator.addMethod('mindate', function(value, element) {
    return this.optional(element) || value >= financialReportsToday();
}, 'Please select today or a later date.');

jq.validator.addMethod('multiemail', function(value, element) {
    if (this.optional(element)) {
        return true;
    }
    var emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    var emails = value.split(',').map(function(email) {
        return email.trim();
    }).filter(Boolean);
    if (!emails.length) {
        return false;
    }
    return emails.every(function(email) {
        return emailPattern.test(email);
    });
}, 'Please enter valid email address(es), separated by commas.');

function initFinancialReportsRadios() {
    const form = document.getElementById('financial-reports-request');
    if (!form) {
        return;
    }
    form.querySelectorAll('.eq-radio input[type="radio"]').forEach(function(radio) {
        radio.removeAttribute('tabindex');
    });
    form.querySelectorAll('.eq-radio label').forEach(function(label) {
        label.removeAttribute('tabindex');
    });
}

function initFinancialReportsFormIntegrations() {
    initFinancialReportsRadios();
    const form = document.getElementById('financial-reports-request');
    const captchaEl = document.getElementById('captcha-financial-reports');
    if (form && captchaEl && !captchaEl.children.length && typeof hcaptcha !== 'undefined') {
        window.captchaIDs[form.id] = hcaptcha.render(captchaEl.id, {
            sitekey: window.hCaptchaSiteKey,
            callback: function(token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token,
                }).appendTo(form);
                form.submit();
            },
        });
    }
    if (typeof validate_forms === 'function') {
        validate_forms();
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const source = document.getElementById('financial-reports-request-form');
    if (!source) {
        return;
    }
    const backupHtml = source.outerHTML;
    setTimeout(initFinancialReportsFormIntegrations, 0);

    // The page cache can serve markup rendered on an earlier day.
    document.addEventListener('click', function(e) {
        if (!e.target.closest('a[href="#financial-reports-request-form"]')) {
            return;
        }
        setTimeout(function() {
            const field = document.getElementById('fr-date');
            if (!field) {
                return;
            }
            const today = financialReportsToday();
            if (field.min < today) {
                field.min = today;
            }
            if (field.value < today) {
                field.value = today;
            }
        }, 0);
    });

    document.addEventListener('click', function(e) {
        const cancel = e.target.closest('#financial-reports-request-cancel');
        if (!cancel) {
            return;
        }
        const form = cancel.closest('form');
        if (form) {
            form.reset();
        }
        const dialog = cancel.closest('dialog');
        if (dialog && typeof dialog.close === 'function') {
            dialog.close();
        }
    });

    document.addEventListener(
        'close',
        function(e) {
            if (!e.target.classList || !e.target.classList.contains('eq-dialog-wrapper')) {
                return;
            }
            setTimeout(function() {
                if (document.getElementById('financial-reports-request-form')) {
                    return;
                }
                const wrap = document.querySelector('.row-financial-reports');
                if (wrap) {
                    wrap.insertAdjacentHTML('afterend', backupHtml);
                    initFinancialReportsFormIntegrations();
                }
            }, 0);
        },
        true
    );
});

